import React from "react";
import { Typography } from "@mui/material";
import { PROJECT_COLOR_DARK } from "../../../constants/colors";

/**
 * プロジェクト用の項番ラベル
 * 例: No.1
 */
export default function ProjectNumberLabel({ index }) {
  return (
    <Typography
      sx={{
        color: PROJECT_COLOR_DARK,
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.2,
      }}
    >
      No.{index}
    </Typography>
  );
}
